import {panelArrowRightSvg as Icon__small__panelArrowRightSvg} from '../Icon__small/Icon__small--panelArrowRight.js'
import {panelArrowRightSvg as Icon__xsmall__panelArrowRightSvg} from '../Icon__xsmall/Icon__xsmall--panelArrowRight.js'

export var panelArrowRight = {
  name: 'panelArrowRight',
  category: 'icon',
  colorable: true,
  svg: Icon__small__panelArrowRightSvg,
  alt: {
    Icon__small: Icon__small__panelArrowRightSvg,
    Icon__xsmall: Icon__xsmall__panelArrowRightSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
